import React, { lazy, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GET_COUPON } from '../../axios/appiendPoints';
import { axiosInstance } from '../../axios/axios';
import { GOLDEN_WALLET, REFER_A_FREIND } from '../../paths/defaultImage';
import { DELIVERY_TYPE, PICKUP_TYPE, PRO } from '../../webStorage/keys/sessionKeys';
import { getOrderType, getOrderTypeSession } from '../../webStorage/manageOrderType';
import SuspenseWrapper from '../common/suspenseWrapper';
import JoinLoyalty from './header/joinLoyalty';
import { MenuCategoryContext } from './menu';

const DiscountPopUp = lazy(() =>
  import(/* webpackChunkName:"DiscountPopUp"*/ '../popUp/discountPopUp')
);
const ReferralInfoPopup = lazy(() =>
  import(/* webpackChunkName:"ReferralInfoPopup"*/ '../popUp/referralInfoPopup')
);

const Discount = ({ showMinLoyaltyForCurrentOrderType = true }) => {
  const sessionSetting = getOrderTypeSession();
  const { t } = useTranslation();
  const orderTypeFromRedux = sessionSetting?.orderType;
  // const orderTimeFromRedux = sessionSetting?.orderTime;
  const [orderTimeFromRedux, setorderTimeFromRedux] = useState(sessionSetting?.orderTime);
  const epochFromRedux = useSelector((state) => state.orderTypeOrderTime?.epoch);
  const restarantIdFromRedux = useSelector((state) => state.restSetting.Setting.id);
  const isReferralEnabled = useSelector(
    (state) => state.restSetting.Setting.settings?.referral?.enabled
  );
  const plan =  useSelector(
    (state) => state.restSetting.Setting.settings?.global?.plan
  );
  const [validDiscount, setValidDiscount] = useState([]);
  const [disPopUp, setDisPopUp] = useState(false);
  const [disDetailForPopUp, setDisDetailForPopUp] = useState({});
  const [openReferralPopup, setOpenReferralPopup] = useState(false);
  const [allDisocunts, setAllDisocunts] = useState();
  const timeFromRedux = useSelector((state) => state.orderTypeOrderTime.orderTime);
  const orderTypeAndTime = useSelector((state) => state.orderTypeOrderTime);

  useEffect(() => {
    let freeDeliveryCoupon = null;
    allDisocunts?.map((discount) => {
      if (discount.discount_type === 'sxgdo') {
        if (freeDeliveryCoupon?.min_amount > discount.min_amount || !freeDeliveryCoupon)
          freeDeliveryCoupon = discount;
      }
    });
    // freeDeliveryCoupon && setFreeDeliveryCoupon(freeDeliveryCoupon);
  }, [allDisocunts]);
  const OpenPromoPopUp = (promoDetail) => {
    // console.log('promo clicked', promoDetail);
    setDisPopUp(true);
    setDisDetailForPopUp(promoDetail);
  };

  const validDiscountCoupons = (allDiscounts) => {
    let discountArray = [];

    allDiscounts.map((discount, index) => {
      let obj = {};
      if (discount.order_type.includes(+orderTypeFromRedux)) {
        obj.couponId = discount['coupon_id'];
        obj.discountType = discount['discount_type'];
        obj.discountValue = discount['value'];
        obj.termAndCondition = discount['tnc'];
        if (discount['title'] !== '' && discount['title'] !== undefined) {
          obj.discountText = discount['title'];
        }
        if (discount['pre_applied'] !== '' && discount['pre_applied'] !== undefined) {
          obj.preApplied = discount['pre_applied'];
          if (discount['pre_applied'] === 1) {
            obj.discountAppliedType = t('auto_applied');
          } else {
            obj.discountAppliedType = discount['code'];
          }
        }
        discountArray.push(obj);
      }
    });
    setValidDiscount(discountArray);
  };

  const getRestaurantDiscount = () => {
    let params = new URLSearchParams();
    params.append('restaurant_id', restarantIdFromRedux);
    params.append('order_type', getOrderType(true));
    // params.append('token', localStorage.getItem('auth_token'));
    if (
      (orderTypeFromRedux == DELIVERY_TYPE || orderTypeFromRedux == PICKUP_TYPE) &&
      sessionSetting.orderTime == 'SCHEDULED' &&
      sessionSetting?.epoch > parseInt(Date.now() / 1000)
    ) {
      params.append('epoch', sessionSetting?.epoch);
      // console.log('time scheduled');
    }
    axiosInstance
      .post(GET_COUPON, params)
      .then((response) => {
        // console.log('response', response.data.data);
        setAllDisocunts(response.data.data);
        validDiscountCoupons(response.data.data);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
  useEffect(() => {
    getRestaurantDiscount();
  }, [
    orderTimeFromRedux,
    timeFromRedux,
    orderTypeAndTime?.orderType,
    epochFromRedux,
    restarantIdFromRedux,
    orderTypeFromRedux,
  ]);
  const { shouldShowLoyalty } = useContext(MenuCategoryContext);
  const discountMainDivCss =
    validDiscount.length > 0
      ? 'horizontalScroll ml-20px gap-2 d-flex flex-row justify-content-start align-items-center'
      : 'ml-20px';

  return (
    <div className='d-flex flex-column gap-12px'>
      {shouldShowLoyalty && (
        <JoinLoyalty
          menu={true}
          img={GOLDEN_WALLET}
          align='right'
          showMinLoyaltyForCurrentOrderType={showMinLoyaltyForCurrentOrderType}
          containerStyles='mr-20px ml-20px'
          contentStyles='br-2 p-2 justify-content-between'
        />
      )}
      <div className={discountMainDivCss}>
        {(!!isReferralEnabled && plan === PRO) && (
          <div
            className='referral-card p-2 d-flex justify-content-between'
            onClick={() => setOpenReferralPopup(true)}>
            <div className='fs-14 fw-500 w-70'>{t('referral_tag')}</div>
          </div>
        )}

        {validDiscount.length > 0 &&
          validDiscount?.map((discount, i) => (
            <div
              key={i}
              className='discountCard p-2 d-flex flex-column justify-content-around'
              onClick={() => OpenPromoPopUp(discount)}>
              <div className='d-flex flex-column discount-cart-text'>
                <div className='mb-0 white discountText fw-600 mx-2 fs-14'>
                  {discount.discountText}
                </div>
                <div className='mb-0 mx-2 white fs-12'>
                  {discount.preApplied
                    ? discount.discountAppliedType
                    : `${t('use')} ${discount.discountAppliedType}`}
                </div>
              </div>
            </div>
          ))}
      </div>

      {disPopUp && (
        <SuspenseWrapper>
          <DiscountPopUp close={() => setDisPopUp(false)} discountDetail={disDetailForPopUp} />
        </SuspenseWrapper>
      )}

      {openReferralPopup && (
        <SuspenseWrapper>
          <ReferralInfoPopup
            close={() => setOpenReferralPopup(false)}
            restId={restarantIdFromRedux}
          />
        </SuspenseWrapper>
      )}
    </div>
  );
};

export default Discount;
